<template>
    <section
        class="SubscribeForm bg--blue-charcoal"
    >
        <div class="SubscribeForm__container container">
            <BaseHeading
                :preheading="preheading"
                :heading="heading"
                tag="h5"
                classes="text--white h5"
            />
            <form
                v-if="!success"
                @submit.prevent="submit"
            >
                <input
                    type="hidden"
                    name="platform"
                    value="campaign-monitor"
                >
                <input
                    type="hidden"
                    name="list"
                    value=""
                >

                <div class="SubscribeForm__input">
                    <input
                        v-model="emailAddress"
                        type="email"
                        name="email"
                        placeholder="Your email address..."
                        required
                        value=""
                    />
                    <div
                        class="SubscribeForm__btn"
                    >
                        <input
                            type="submit"
                        />
                        <BaseIcon
                            icon="arrow-left"
                            color="white"
                        />
                    </div>
                </div>
                <div class="Subscribe__checkbox">
                    <input
                        v-model="termsChecked"
                        type="checkbox"
                        name="terms"
                    />
                    <label>
                        Yes I have read and agreed to the
                        <a
                            href="/privacy-policy"
                        >
                            Privacy Policy
                        </a>
                    </label>
                </div>
                <span
                    v-if="submitted && !termsChecked"
                    class="SubscribeForm__error"
                >
                    You need to agree with terms & conditions
                </span>
            </form>
            <div
                v-else
                class="SubscribeForm__success"
            >
                Thanks, <br /> you have been subscribed
            </div>
        </div>
    </section>
</template>
<script>
import axios from 'axios';
import qs from 'qs';

export default {
    name: 'SubscribeForm',
    props: {
        heading: {
            type: String,
            default: null
        },
        preheading: {
            type: String,
            default: null
        },
        text: {
            type: String,
            default: ''
        },
        list: {
            type: String,
            default: 'Visitgippsland.com.au subscriber list'
        }
    },
    data() {
        return {
            submitted: false,
            success: false,
            termsChecked: false,
            emailAddress: ''
        }
    },
    methods: {
        submit() {
            this.submitted = true

            if (this.termsChecked) {
                const data = {
                    action: 'e7newsletter/default/subscribe',
                    email: this.emailAddress,
                    platform: 'campaign-monitor',
                    list: this.$props.list,
                    [window.csrfTokenName]: window.csrfTokenValue,
                };

                axios.post('/', qs.stringify(data))
                    .then(() => {
                        this.success = true
                        window.dataLayer.push({
                            event: 'newsletter_success'
                        })
                    })
                    .catch(() => {
                        document.querySelector('.SubscribeForm__input').classList.add('has-error');
                    });
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .SubscribeForm {
        padding: getSpacing('large') 0;

        form {
            position: relative;

            @include media-query(palm) {
                margin-top: getSpacing('spacer');
            }

            @include media-query(lap-and-up) {
                 -ms-grid-column: 2;
                -ms-grid-row: 1;
                align-self: center;
            }
        }

        .BaseHeading {
            @include media-query(lap-and-up) {
                -ms-grid-column: 1;
                -ms-grid-row: 1;
                align-self: center;
            }
        }
    }

    .SubscribeForm__container {
        @include media-query(lap-and-up) {
            display:-ms-grid;
            display: grid;
            -ms-grid-columns: 1fr 1fr;
            grid-template-columns: repeat(2, 1fr);
            -ms-grid-rows: 1fr;
            grid-template-rows: repeat(1, 1fr);
        }
    }

    .SubscribeForm__input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid rgba(getColor('white'), 0.35);
        color: getColor('white');
        width: 100%;

        input {
            background: transparent;
            border: none;
            width: calc(100% - 50px);
            height: 100%;
            font-size: 1rem;
            padding: 1rem;
            color: getColor('white');

            @include media-query(lap-and-up) {
                width: calc(100% - 72px);
            }
        }

        .BaseIcon {
            padding: getSpacing('small');
            border-right: 1px solid rgba(getColor('white'), 0.35);
            width: 50px;
            height: 50px;
            transform: rotate(180deg);
            padding: 12px;
            pointer-events: none;

            @include media-query(lap-and-up) {
                width: 72px;
                height: 72px;
                padding: 20px;
            }

            &:hover {
                opacity: 0.8;
            }
        }
    }

    .SubscribeForm__error {
        font-size: 16px;
        color: $error-color;
        font-weight: 700;
        position: absolute;
        bottom: -2rem;
    }

    .SubscribeForm__btn {
        position: relative;

        input {
            position: absolute;
            width: 100%;
            height: 100%;
            opacity: 0;
            cursor: pointer;
        }
    }

    .BaseButton {
        line-height: 1;
        padding: 0;
        background: transparent;
    }

    .Subscribe__checkbox {
        position: relative;
        margin-top: getSpacing('base');

        input {
            position: absolute;
            top: 0;
            left: 0;
            width: 20px;
            height: 100%;
            cursor: pointer;
            opacity: 0;
        }

        input:checked ~ label:after {
            display: block;
        }

        label {
            display: block;
            position: relative;
            padding-left: 35px;
            pointer-events: none;
            cursor: pointer;
            color: getColor('white');
            font-size: 14px;

            a {
                font-weight: 700;
                pointer-events: all;
                color: getColor('white');
            }

            &:before {
                content: '';
                display: block;
                position: absolute;
                width: 24px;
                height: 24px;
                border: 2px solid getColor('white');
                left: 0;
                top: -3px;
                border-radius: 4px;
            }

            &:after {
                content: "\2713";
                display: none;
                font-weight: bold;
                position: absolute;
                top: 1px;
                left: 6px;
            }
        }
    }

    .SubscribeForm__success {
        display: flex;
        align-items: center;
        justify-content: center;
        -ms-grid-column: 2;
        -ms-grid-row: 1;
        grid-column: 2;
        grid-row: 1;
        color: getColor('white');
    }

    ::-webkit-input-placeholder {
        color: rgba(getColor('white'), 0.6)!important;
        text-shadow: none!important;

        .has-error & {
            color: $error-color!important;
        }
    }

    ::-moz-placeholder {
        color: rgba(getColor('white'), 0.6)!important;
        text-shadow: none!important;

        .has-error & {
            color: $error-color!important;
        }
    }

    :-ms-input-placeholder {
        color: rgba(getColor('white'), 0.6)!important;
        text-shadow: none!important;

        .has-error & {
            color: $error-color!important;
        }
    }

    :-moz-placeholder {
        color: rgba(getColor('white'), 0.6)!important;
        text-shadow: none!important;

        .has-error & {
            color: $error-color!important;
        }
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        transition: background-color 5000s ease-in-out 0s;
         -webkit-text-fill-color: getColor('white')!important;
    }
</style>
